import { __styles } from '@griffel/react';
import { typographyStyles } from '@fluentui/react-theme';
export const subtitle2StrongerClassNames = {
  root: 'fui-Subtitle2Stronger'
};
/**
 * Styles for the root slot
 */
export const useSubtitle2StrongerStyles = /*#__PURE__*/__styles({
  root: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "fod5ikn",
    Bhrd7zp: "flh3ekv",
    Bg96gwp: "faaz57k"
  }
}, {
  d: [".fk6fouc{font-family:var(--fontFamilyBase);}", ".fod5ikn{font-size:var(--fontSizeBase400);}", ".flh3ekv{font-weight:var(--fontWeightBold);}", ".faaz57k{line-height:var(--lineHeightBase400);}"]
});